import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import Swal from 'sweetalert2'
import {Column} from 'react-table'
import {AttendClaimDocument} from '../../../../model/claim.model'
import {
  finalizeClaim,
  getAttentionList,
  downloadClaimDocumentsAttentionService,
  downloadClaimDocumentsAttentionServiceV,
} from '../../../../services/claim.service'
import {useCentral} from '../../../../../../hooks/useCentral'
import {ModalAttendClaim} from '../modal/ModalAttendClaim'
import {formatDateDDMMYYYY} from '../../../../../../util/dates'
import {TabCentralModel} from '../../../../../../models'
import {ShowSnackBar} from '../../../../../../util/functions'
import {getSnackBarToast} from '../../../../../../util/snackBar'
const TableAttendClaim: FC = () => {
  const {data, setData, loading, setLoading, pagination} = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const [showModal, setShowModal] = useState(false)
  const [createdModal, setCreatedModal] = useState(false)
  const [claimToEdit, setClaimToEdit] = useState<AttendClaimDocument | any>()

  const handleNew = () => {
    setShowModal(true)
    setCreatedModal(true)
  }

  const getAttendList = async () => {
    setLoading(true)
    const {data: response} = await getAttentionList(currentTabItem.idToEdit as any)
    if (!response.error) {
      setData(response.data)
    }
    setLoading(false)
  }

  const handleFinish = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'De finalizar este reclamo',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, finalizar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      const obj: TabCentralModel = {
        ...currentTabItem,
        loadingTable: true,
      }
      changeCurrentTabItem(obj)
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const {data: response} = await finalizeClaim(currentTabItem.idToEdit)
        if (!response.error) {
          ShowSnackBar('Se finalizo satisfactoriamente')
          getAttendList()
          const obj2: TabCentralModel = {
            ...currentTabItem,
            loadingTable: false,
          }
          changeCurrentTabItem(obj2)
        } else {
          ShowSnackBar(response.message, 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleEdit = (item: AttendClaimDocument) => {
    setClaimToEdit(item)
    setShowModal(true)
    setCreatedModal(false)
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    getAttendList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    setLoading(false)
    getAttendList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])
  const handleDownload = async (attendClaim: AttendClaimDocument) => {
    try {
      const response = await downloadClaimDocumentsAttentionServiceV(attendClaim.Id)
      const contentType = response.headers['content-type'] || 'application/octet-stream'
      const blob = new Blob([response.data], {type: contentType})

      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${attendClaim.NombreDocumento}` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      getSnackBarToast('Hubo un error', 'error')
    }
  }
  const columns: Column<AttendClaimDocument>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Rquerimiento' />,
      accessor: 'TipoRequerimiento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Responsable' />,
      accessor: 'Responsable_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cargo del Responsable' />,
      accessor: 'Responsable_cargo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Empresa del Responsable' />,
      accessor: 'Responsable_empresa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Teléfono del Responsable' />,
      accessor: 'Responsable_telefono',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Email del Responsable' />,
      accessor: 'Responsable_email',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de Atención' />,
      accessor: 'FechaAtencion',
      Cell: ({...props}) => <div>{formatDateDDMMYYYY(props.row.original.FechaAtencion)}</div>,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Atención' />,
      accessor: 'Atencion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <div className='d-flex'>
          {isAllowed('ATENDREQUERIMIENTO/DESCARGAR')
            ? props.data[props.row.index].UrlDocumento && (
                <div
                  className='d-flex justify-content-center flex-shrink-0'
                  onClick={() => handleDownload(props.row.original)}
                >
                  <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                    <KTSVG path='/media/icons/duotune/arrows/arr091.svg' className='svg-icon-3' />
                  </a>
                </div>
              )
            : null}
          {isAllowed('ATENDREQUERIMIENTO/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0 ms-3'
              onClick={() => handleEdit(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </div>
      ),
    },
  ]

  return (
    <>
      {isAllowed('ATENDREQUERIMIENTO/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('ATENDREQUERIMIENTO/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
            {isAllowed('ATENDREQUERIMIENTO/FINALIZAR') && (
              <button
                className='btn btn-success me-3'
                onClick={handleFinish}
                type='button'
                disabled={data.length < 1}
              >
                Finalizar Reclamo
              </button>
            )}
          </div>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          {showModal ? (
            <ModalAttendClaim
              show={showModal}
              setShow={setShowModal}
              claimToEdit={claimToEdit}
              getAttentionList={getAttendList}
              created={createdModal}
            />
          ) : (
            <></>
          )}
        </KTCard>
      )}
    </>
  )
}

const TableAttendClaimWrapper = () => {
  return (
    <KTableProvider>
      <TableAttendClaim />
    </KTableProvider>
  )
}

export {TableAttendClaimWrapper}
